import { render } from "./DTSelect.vue?vue&type=template&id=c8688d70&scoped=true"
import script from "./DTSelect.vue?vue&type=script&lang=js"
export * from "./DTSelect.vue?vue&type=script&lang=js"

import "./DTSelect.vue?vue&type=style&index=0&id=c8688d70&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8688d70"]])

export default __exports__